import React from "react";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import AdminAnalyticsPage from "pages/AdminView/AdminAnalyticsPage/AdminAnalyticsPage";
import RecruiterAnalyticsPage from "pages/RecruitersView/RecruiterAnalyticsPage/RecruiterAnalyticsPage";
import ErrorPage from "pages/ErrorPage/ErrorPage";

export default function AnalyticsSwitch() {
  const appContext = useAppContext();
  const { account } = appContext;
  const { accountType } = account;

  if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
    return <AdminAnalyticsPage />;
  } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
    return <RecruiterAnalyticsPage />;
  } else {
    return <ErrorPage />;
  }
}
